<template>
  <div>
    <el-dialog
      width="680px"
      title="加入申请"
      :visible="joinApplyVisi"
      :close-on-click-modal="false"
      :before-close="handleClose"
    >
      <div v-loading="loading">
        <div v-if="joinApplyList.length > 0">
          <div class="list">
            <div class="info-box" v-for="item of joinApplyList" :key="item.id">
              <div class="info-title">
                <img src="/images/web/p-default.png" alt="" />
                <div class="info-text">
                  <p>
                    <span class="name">{{ item.userName }}</span>
                  </p>
                  <p><span>账号：</span>{{ item.targetId }}</p>
                  <p><span>备注：</span>{{ item.remark }}</p>
                </div>
              </div>
              <div class="btns">
                <div>
                  <el-button
                    type="danger"
                    size="mini"
                    style="margin-bottom:10px"
                    @click="chooseDepartFn(item)"
                    >同意</el-button
                  >
                </div>
                <div>
                  <el-button size="mini" @click="refuseCount(item)"
                    >拒绝</el-button
                  >
                </div>
              </div>
            </div>
          </div>

          <!--分页-->
          <el-row class="pageation row" v-if="pageInfo.total > 0">
            <el-col :span="24" class="page-flex-end">
              <el-pagination
                @current-change="handleCurrentChange"
                :current-page="pageInfo.itemPage"
                :page-size="pageInfo.pageSize"
                layout=" prev, pager, next, total"
                :total="pageInfo.total"
              />
              <el-go
                :page-size="pageInfo.pageSize"
                :total="pageInfo.total"
                @current-change="handleCurrentChange"
              ></el-go>
            </el-col>
          </el-row>
          <!-- 备注 -->
        </div>
        <el-empty v-else description="暂无申请"></el-empty>
      </div>
    </el-dialog>
<!--    选择部门-->
    <chooseDepartment :show.sync="chooseDepartVisible" @departDataEmit="departDataEmit"/>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import ElGo from "../../../go/Go.vue";
import Bus from "@/plugins/bus.js";
import chooseDepartment from "./chooseDepartment";

export default {
  props: { joinApplyVisi: Boolean, viewIndex: Boolean },
  components: { ElGo, chooseDepartment },
  data() {
    return {
      chooseDepartData: {},
      chooseDepartVisible: false,
      joinApplyList: [],
      loading: false,
      refuseForm: { remark: "" },
      pageInfo: {
        pageSize: 10,
        itemPage: 1,
        total: 10
      }
    };
  }, // data end
  methods: {
    /** 换页 */
    handleCurrentChange(val) {
      this.pageInfo.itemPage = val;
      this.getList();
    },
    /**关闭弹窗 */
    handleClose() {
      this.$emit("update:joinApplyVisi", false);
    },
    //选择部门
    chooseDepartFn(item) {
      this.chooseDepartData = item;
      this.chooseDepartVisible = true;
    },
    departDataEmit(data) {
      let item = {...data, ...this.chooseDepartData};
      this.applyOrRefuse(item, 2)
    },
    /**同意 */
    applyOrRefuse(item, status) {
      this.loading = true;
      let FD = new FormData();
      FD.append("id", item.id);
      FD.append("status", status); // 状态 2通过,3拒绝
      if (status === 2) {
        FD.append("corpGroupId", item.corpGroupId);
        FD.append("corpSealIds", item.corpSealIds);
      }
      // 刘总说不要拒绝理由了
      // if (status == 3) {
      //   FD.append("remark", this.refuseForm.remark);
      // }
      ApiMethods.accountJoin
        .uditUser(FD)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.$emit('refresh')
          this.$message.success(res.description);
          this.getList();
          // this.grantNow();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /** 拒绝 */
    refuseCount(item) {
      this.$confirm('是否要拒绝', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        showCancelButton: false
      }).then(() => {
        this.applyOrRefuse(item, 3);
      }).catch(() => {
      });
    },
    // 是否立即授予权限
    grantNow() {
      const title = "提示",
        message = "已同意该成员加入企业，是否立即授予权限";
      this.$confirm(message, title, {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.handleClose();
          Bus.$emit("listenClickTab", "member");
        })
        .catch(() => {});
    },
    /** 查询列表 */
    getList() {
      this.loading = true;
      let FD = new FormData();
      const { pageSize, itemPage } = this.pageInfo;
      FD.append("pageSize", pageSize);
      FD.append("itemPage", itemPage);
      ApiMethods.accountJoin
        .auditUserList(FD)
        .then(res => {
          if (!res.success) return this.$message.error(res.description);
          this.joinApplyList = res.data;
          this.pageInfo.total = res.total;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    joinApplyVisi(val) {
      if (val && this.viewIndex) {
        this.getList();
      }
    }
  },
  mounted() {
    if (!this.viewIndex) {
      this.getList();
    }
  }
};
</script>

<style scoped lang="less">
.list {
  height: 520px;
  overflow: auto;
}
.info-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  padding: 10px 5px;
  border-radius: 4px;

  .btns {
    display: flex;
    flex-direction: column;
  }
}
.info-title {
  display: flex;
  align-items: center;
  > img {
    width: 65px;
    height: 65px;
    border-radius: 50%;
  }
  .info-text {
    width: 460px;
    margin-left: 10px;
    .name {
      font-weight: bold;
    }
    .status {
      display: inline-block;
      width: 51px;
      margin-left: 15px;
      border-radius: 15px;
      text-align: center;
      font-size: 12px;
    }
    .not {
      border: 1px solid #ccc;
      color: #ccc;
    }
    .suc {
      border: 1px solid #7ed2f7;
      color: #7ed2f7;
    }
  }
}
.pageation {
  padding: 30px 10px 20px 10px;
  border-top: 0;
}
</style>



// WEBPACK FOOTER //
// components/console/memberManage/components/joinApply.vue